import { Link } from 'gatsby';
import { OutboundLink } from 'gatsby-plugin-gtag';
import { EuiSpacer } from '@elastic/eui';
import TableFeatures from 'components/Outdoor_Cameras/IN-9010_HD/Product_Features/TableFeatures';
import NavButtons from 'components/Outdoor_Cameras/IN-9010_HD/NavButtons';
import BreadCrumbs from 'components/Layout/BreadCrumbs';
import SEOHelmet from 'components/Layout/SEOHelmet';
import * as React from 'react';
export default {
  Link,
  OutboundLink,
  EuiSpacer,
  TableFeatures,
  NavButtons,
  BreadCrumbs,
  SEOHelmet,
  React
};